var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-loading"},[_c('veui-loading',{attrs:{"loading":"","ui":"strong l"}},[_vm._v(" "+_vm._s(_vm.text || '加载中')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }